import { Accordion } from '@dreryk/react-components';

import { serviceSettingsTranslationKeys } from '../translations';

import { AdvancePaymentsSettings } from './advancePayments/AdvancePaymentsSettings';

export const ServiceSettingsPanel = (): JSX.Element => {
   return (
      <Accordion testId={'settings'} defaultOpenedSectionsIds={'advancePayments'}>
         <Accordion.Section
            id={'advancePayments'}
            testId={'advancePayments'}
            label={serviceSettingsTranslationKeys.advancePayments.header}
         >
            <AdvancePaymentsSettings />
         </Accordion.Section>
      </Accordion>
   );
};
